<template>
    <nav class="category-list">
        <router-link class="category-list__item"
                     v-bind:key="category.id"
                     v-bind:to="getListLinkComputed(category.id)"
                     v-for="category in categories"
                     v-if="categories.length > 0 && listLink && hasChildren(category)"
        >
            {{ category.name }}
        </router-link>

        <a class="category-list__item"
           v-bind:class="{ 'is-active' : activeCategory == null }"
           v-if="categories.length > 0 && !listLink && showAll && !parentFilter"
           v-on:click="handleCategoryChange(null)"
        >
            {{ __('All') }}
        </a>

        <a class="category-list__item"
           v-bind:class="{ 'is-active' : activeCategory == null }"
           v-if="!listLink && parentFilter"
           v-on:click="handleBack()"
        >
            {{ __('Back') }}
        </a>

        <a class="category-list__item"
           v-bind:class="{ 'is-active' : activeCategory == category.id }"
           v-bind:key="category.id"
           v-for="category in categories"
           v-if="categories.length > 0 && !listLink"
           v-on:click="handleCategoryChange(category.id)"
        >
            {{ category.name }}
            {{ category.tiles_count }}
        </a>
    </nav>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                categories: [],
                history: [],
                parentFilter: this.parentId
            }
        },
        methods: {
            getCategories: function () {
                this.categories = [];

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/' + this.categoryType + '/categories', {
                    params : {
                        filters: {
                            parent: this.parentFilter
                        },
                        page: 1,
                        perPage: 0
                    }
                }).then(function (response) {
                    let categories = response.body.original.data;
                    this.categories = categories;

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });


            },
            getListLinkComputed: function (category) {
                let listLinkComputed = JSON.parse(JSON.stringify(this.listLink)); // force shallow copy

                if (typeof listLinkComputed.params == 'undefined') {
                    listLinkComputed.params = {};
                }

                listLinkComputed.params.category = category;

                return listLinkComputed;
            },
            handleBack: function () {
                let $prevCategory = this.history.length > 0 ? this.history[this.history.length-1] : null;
                this.history.pop();

                this.updateParentCategory($prevCategory);

                this.getCategories();


            },
            handleCategoryChange: function (category) {
                if (this.parentFilter) {
                    this.history.push(this.parentFilter);
                }
                this.updateParentCategory(category);
                this.getCategories();
            },
            hasChildren: function (category) {
                if ((this.categoryType == 'tiles' && category.tiles_count > 0)) {
                    return true;
                } else if ((this.categoryType == 'startdesks' && category.startdesks_count > 0)) {
                    return true
                } else if (this.categoryType == 'tiles' || this.categoryType == 'startdesks') {
                    return false;
                }
                return true;
            },
            init: function () {
                this.getCategories();
            },
            updateParentCategory: function (category) {
                this.parentFilter = category;

                this.$parent.updateCategory(category);
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            activeCategory: {
                default: null,
                type: Number
            },
            categoryType: {
                required: true,
                type: String
            },
            listLink: {
                default: null,
                type: Object
            },
            parentId: {
                default: null,
                type: Number
            },
            showAll: {
                default: false,
                type: Boolean
            }
        },
        watch: {
            category: function () {
                this.parentFilter = this.parentId;
            },
            parentId: function () {
                this.parentFilter = this.parentId;
                this.getCategories();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CategoryList.vue